import { getSelectorAttribute, usagePageSelectors } from '@vy/app-selectors';
import { Meter } from '@vy/types';
import { withDefault } from '@vy/utils';
import React from 'react';
import { VyMultipleAutoComplete } from '../../../../components/new-design/inputs/VyMultipleAutoComplete';

type ProductAutocompleteProps = {
  filterMeters: Meter[];
  selectedMetersIds: string[];
  setSelectedMetersIds: (ids: string[]) => void;
};

export const ProductAutocomplete: React.FC<ProductAutocompleteProps> = ({
  filterMeters,
  selectedMetersIds,
  setSelectedMetersIds,
}) => {
  const selectedMeters = filterMeters.filter((meter) =>
    withDefault(selectedMetersIds, []).includes(meter.id),
  );

  return (
    <VyMultipleAutoComplete
      options={filterMeters}
      value={selectedMeters}
      onChange={(newValue) => setSelectedMetersIds(newValue.map((meter) => meter.id))}
      getOptionLabel={(meter) => meter.name}
      label="Product"
      showSelectAll={true}
      size="small"
      sx={{
        width: '450px',
        minWidth: '450px',
        maxWidth: '450px',
        flexShrink: 0,
        '& .MuiInputBase-root': {
          borderRadius: '8px',
        },
      }}
      textFieldProps={{
        ...getSelectorAttribute(usagePageSelectors.header.productDropdownButton),
      }}
    />
  );
};
